export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    resetExpiredPassword(_, password) {
      return this._vm.$axios.put('/api/auth/reset-password-expired', {password})
    },
    sendForgotPasswordEmail(_, username) {
      return this._vm.$axios.post('/api/auth/password/email', {username})
    },
    updatePassword(_, payload) {
      return this._vm.$axios.post('/api/auth/password/email', payload)
    },
    resetPassword(_, payload) {
      return this._vm.$axios.post('/api/auth/password/reset', payload)
    },
  },
  getters: {},
}

export const logout = function (commit, router) {
  commit('setLoggedOut', true, {root: true});
  router.replace({name: 'login'}).catch(() => {})
}